import { gql } from 'apollo-angular';
export var update_address = gql`
  mutation updateAddress($id: ID!, $input: AddressInput!) {
    updateAddress(id: $id, input: $input) {
      id, address1, address2, latitude, longitude, is_verified,
      zipCode{
        zipcode, city,
        state{
          abbreviation
        },
        county{
          name,
          metroStatAreaCounties{
            metroStatArea{
                name
            }
          }
        }
      }
    }
  }
`;

export var create_address = gql`
  mutation createAddress($input: AddressInput!) {
    createAddress(input: $input) {
      id, address1, address2, latitude, longitude, is_verified,
      zipCode{
        zipcode, city,
        state{
          abbreviation
        },
        county{
          name,
          metroStatAreaCounties{
            metroStatArea{
              name
            }
          }
        }
      }
    }
  }
`;

export var create_address_for_company_event = gql`
    mutation createAddressForCompanyEvent($input: CompanyEventAddressInput!) {
      createAddressForCompanyEvent(input: $input){
        id
        address1
        address2
        zipCode{
          zipcode,
          city,
          state {
            abbreviation
          }
        }
        company_event_addresses{
          name
          id
          address_id
        }
      }
    }
`

export var update_address_for_company_event = gql`
    mutation updateAddressForCompanyEvent($id: ID!, $input: CompanyEventAddressInput!){
      updateAddressForCompanyEvent(id: $id, input: $input){
        id
        address1
        address2
        zipCode{
          zipcode
          city
          state {
            abbreviation
          }
        }
        company_event_addresses{
          name
          id
          address_id
        }
      }
    }
`

export var get_zipcode = gql`
  query getZipCode($zipcode: String, $city: String, $state: Mixed, $county: Mixed) {
    zipCodeWithCityStateAndCounty(
      zipcode: $zipcode,
      city: $city,
      hasState: { column: ABBREVIATION, operator: EQ, value: $state },
      hasCounty: { column: NAME, operator: EQ, value: $county }) {
        id
    },
    zipCodeWithCityState(
      zipcode: $zipcode,
      city: $city,
      hasState: { column: ABBREVIATION, operator: EQ, value: $state }){
      id
    },
    zipCodeWithCity(zipcode: $zipcode, city: $city){
      id
    },
    zipCode(zipcode: $zipcode){
      id
    },
    noZipCityState(
      city: $city,
      hasState: { column: ABBREVIATION, operator: EQ, value: $state }){
      id
    }
  }
`;

export var delete_address = gql`
    mutation deleteAddress($id: ID!){
      deleteAddress(id: $id){
        id
      }
    }
`
